import { z } from 'zod';

export const sceneDiagnosticSeveritySchema = z.enum([
  'info',
  'warning',
  'error',
]);

export const sceneDiagnosticSourceSchema = z.enum([
  'schema',
  'semantic',
  'compiler',
  'layout',
  'relation',
  'asset',
  'timeline',
  'interaction',
  'camera',
  'data-view',
  'reconciler',
  'pixi-runtime',
  'performance',
]);

export const sceneDiagnosticSchema = z.object({
  code: z.string().min(1),
  severity: sceneDiagnosticSeveritySchema,
  path: z.string().default(''),
  relatedIds: z.array(z.string().min(1)).max(100).default([]),
  message: z.string().min(1),
  availableCapabilities: z.array(z.string().min(1)).max(100).default([]),
  suggestedFix: z.string().default(''),
  autoFixable: z.boolean().default(false),
  source: sceneDiagnosticSourceSchema,
}).strict();

export type SceneDiagnostic = z.infer<typeof sceneDiagnosticSchema>;
export type SceneDiagnosticSeverity = z.infer<
  typeof sceneDiagnosticSeveritySchema
>;
export type SceneDiagnosticSource = z.infer<
  typeof sceneDiagnosticSourceSchema
>;

export function createSceneDiagnostic(
  input: Omit<
    SceneDiagnostic,
    'relatedIds' | 'availableCapabilities' | 'suggestedFix' | 'autoFixable'
  > & Partial<Pick<
    SceneDiagnostic,
    'relatedIds' | 'availableCapabilities' | 'suggestedFix' | 'autoFixable'
  >>,
): SceneDiagnostic {
  return sceneDiagnosticSchema.parse({
    relatedIds: [],
    availableCapabilities: [],
    suggestedFix: '',
    autoFixable: false,
    ...input,
  });
}
